import { Button, useMediaQuery, useTheme } from '@mui/material'
import React, { useCallback } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useNavigate, useParams } from 'react-router-dom'
import useModals from 'src/Hooks/useModals'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners/types'
import { extensionColors } from '../../../colors'
import LuoxEnergyIconSvg from '../../../resources/LuoxEnergySvg'
import { Banner } from 'src/Components/banner'
import useInstallationExtensionData from '../../../hooks/extensions/use-installation-extension-data'
import { getExtensionContractState } from 'src/Libs/installation-extensions/utils'
import { ExtensionTypes } from 'src/Libs/installation-extensions/types'

interface StyleProps {
  downMd: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  containerStyle: {
    backgroundColor: extensionColors.luoxDirectMarketing.primary,
  },
  infoButton: {
    minWidth: 'max-content',
    color: extensionColors.luoxDirectMarketing.secondary,
    borderColor: extensionColors.luoxDirectMarketing.secondary,
    '&:hover': {
      borderColor: theme.palette.grey.grey05,
    },
  },
}))

/**
 * This component displays a banner informing about the direct marketing extension.
 */
const DirectMarketingBanner: React.FC = () => {
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const { classes } = useStyles({ downMd })
  const { t } = useCustomTranslation()

  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()

  const { openLuoxDirectMarketingModal } = useModals()
  const navigate = useNavigate()
  const { installationExtensionsState } = useInstallationExtensionData(installationId)
  const extensionState = getExtensionContractState(installationExtensionsState, ExtensionTypes.LuoxOne)

  const redirectToInstallationExtensions = useCallback(() => {
    navigate(`/installation-extensions/${installationId}/${storageId}`)
    openLuoxDirectMarketingModal({ extensionState })
  }, [installationId, storageId, history]) // eslint-disable-line

  return (
    <Banner
      bannerKey={BannerKey.DirectMarketing}
      button={
        <Button className={classes.infoButton} onClick={redirectToInstallationExtensions}>
          {t('installation-extension.banner.more-information-button')}
        </Button>
      }
      icon={<LuoxEnergyIconSvg />}
      i18nKey="installation-extension.banner.information"
      containerStyle={classes.containerStyle}
      onRemoveSuccessMessageKey="installation-extension.banner.where-to-find"
      closeType={BannerCloseTypes.permanentOrTemporary}
    />
  )
}

export default DirectMarketingBanner
